import { AT_NEW_VALUES_PERSIST, ICookieDialogNewValuesPersistAction } from './types';

export const newValuesPersist = (
): ICookieDialogNewValuesPersistAction => ({
    type: AT_NEW_VALUES_PERSIST
});
